import { supabase } from './supabase';

/**
 * De volledige marketingmail zoals verstuurd — leeslaag op
 * `GET /api/marketing/send-body`.
 */

export type SendBodySource = 'opgeslagen' | 'reconstructie' | 'onbeschikbaar';

export interface MarketingSendBody {
  id: string;
  subject: string | null;
  toEmail: string | null;
  status: string | null;
  sentAt: string | null;
  brand: string | null;
  suppressedReason: string | null;
  via: string | null;
  templateKey: string | null;
  discountOffer: { code: string | null; percentage: number; scope: string; label: string } | null;
  /** Waar de inhoud vandaan komt. `opgeslagen` = bewijs, `reconstructie` = benadering. */
  source: SendBodySource;
  /** Alleen bij reconstructie: draait de template nog op dezelfde versie? */
  templateVersionMatch: boolean | null;
  warning: string | null;
  html: string | null;
  text: string | null;
}

export async function fetchMarketingSendBody(sendId: string): Promise<MarketingSendBody> {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error('Niet ingelogd');

  const response = await fetch(`/api/marketing/send-body?id=${encodeURIComponent(sendId)}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || 'Mail ophalen mislukt');
  }
  return response.json();
}
